import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQ = [
    {
        q: 'What is Arrowise?',
        a: 'Arrowise is a platform for asynchronous, task-based technical interviews that lets hiring teams evaluate how candidates use AI as well as how they organize and structure code. Candidates work in a contained browser experience and reviewers inspect the timeline of prompts, edits, and key moments.'
    },
    {
        q: 'How does it work?',
        a: 'Candidates join with a session code and complete an ordered set of task-based steps inside the browser. Each step provides a built-in code editor and an AI chat assistant. Every prompt, AI response, code snapshot, and step transition is recorded so hiring teams can replay the session and review both the prompts and the resulting code structure.'
    },
    {
        q: 'What makes Arrowise different?',
        a: 'Instead of live interviews, Arrowise captures how a candidate iterates with AI: prompt design, iteration strategy, and code organization. The focus is on AI fluency and engineering thoughtfulness, not whether the code runs locally.'
    },
    {
        q: 'Is there a free tier?',
        a: 'Yes. The Free plan lets you try the workflow with one active session at a time and use your own API key (bring your own provider).'
    },
    {
        q: 'How does the Team tier work?',
        a: 'Team adds multi-seat management, session replay, shared templates, and review workflows (coming soon) so teams can collaborate on candidate assessments and access analytics.'
    },
    {
        q: 'How does AI help in the interview process?',
        a: 'Candidates are expected to use the built-in AI to produce most of the code — the assessment measures how well they craft prompts, iterate, and organize the AI output. All AI interactions are logged and become part of the review bundle.'
    },
    {
        q: 'Can candidates use external tools or search?',
        a: 'No - candidates should stay in the provided tab and use the in-app AI for assistance. The platform evaluates prompt quality and iteration, so any external "cheating" would both be unnecessary and would not be captured in the replay. If something goes wrong, candidates should contact their recruiter.'
    },
];

export function FAQAccordion() {
    return (
        <section id="faq" className="py-24 border-t">
            <div className="mx-auto max-w-3xl px-4">
                <h2 className="text-3xl font-semibold tracking-tight mb-8 text-center">Frequently Asked Questions</h2>
                <Accordion type="single" collapsible className="w-full">
                    {FAQ.map((f, i) => (
                        <AccordionItem key={i} value={`item-${i}`}>
                            <AccordionTrigger>{f.q}</AccordionTrigger>
                            <AccordionContent>{f.a}</AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
